// Roles tab: shows the three brand-mint client roles the backend exposes at
// GET /v1/admin/roles (service-admin / customer-admin / field-engineer).
import { useEffect, useState } from "react";
import { ApiError, listRoles } from "../api";
import { Banner } from "./Banner";

export function RolesTab() {
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await listRoles();
        if (!cancelled) setRoles(r);
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof ApiError || e instanceof Error ? e.message : "Unexpected error.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section aria-labelledby="roles-heading">
      <h2 id="roles-heading" className="sr-only">
        Roles
      </h2>
      {error && <Banner kind="error">{error}</Banner>}
      <div className="card">
        <h2>brand-mint client roles</h2>
        {loading ? (
          <p className="muted">Loading…</p>
        ) : roles.length === 0 ? (
          <p className="muted">No roles reported by the server.</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((r) => (
                <tr key={r}>
                  <td>
                    <span className="role-tag">{r}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}
